module.exports = __webpack_public_path__ + "gm_slide_mobile.jpg";